// CarouselWrapper.js
import React, { useState, useEffect } from "react";
import Carousel from "./car"; // desktop
import CarouselMobile from "./carmobile"; // mobile

const CarouselWrapper = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile ? <CarouselMobile /> : <Carousel />;
};

export default CarouselWrapper;
